// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.OverlayContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import OverlayFallbackComponent from 'share/components/controls/Izenda.OverlayFallbackComponent';
import { get, omit } from 'lodash/fp';

class OverlayContainer extends Component {
  static defaultProps = {
    OverlayComponent: OverlayFallbackComponent
  };

  render() {
    const { children, OverlayComponent, showOverlay, classNames } = this.props;
    let { overlayComponentProps } = this.props;
    const overlayClassNames = ['izenda-Overlay-Fallback', get('classNames', overlayComponentProps)].join(' ');

    overlayComponentProps = omit(['classNames'], overlayComponentProps);

    if (!!showOverlay) {
      return (
        <section className={classNames}>
          {children}
          <OverlayComponent className={overlayClassNames} {...overlayComponentProps} />
        </section>
      );
    }

    return children;
  }
}

export const withOverlay = (Component: any, OverlayComponent: any): any => (props: any) => {
  const { showOverlay, classNames, overlayComponentProps } = props;
  const childrenProps = omit(['showOverlay', 'classNames', 'overlayComponentProps'], props);
  return (
    <OverlayContainer
      showOverlay={showOverlay}
      className={classNames}
      OverlayComponent={OverlayComponent}
      overlayComponentProps={overlayComponentProps}
    >
      <Component {...childrenProps} />
    </OverlayContainer>
  );
};

export default OverlayContainer;



// WEBPACK FOOTER //
// ./ui/share/components/hoc/Izenda.OverlayContainer.js